export default __webpack_public_path__ + "static/media/403.471e1e18.svg";